(() => {
  const TAG = 'product-showcase-carousel';

  class ProductShowcaseCarousel extends HTMLElement {
    connectedCallback() {
      this.images = [...this.querySelectorAll('[data-showcase-image]')];
      this.contents = [...this.querySelectorAll('[data-showcase-content]')];
      this.prevBtn = this.querySelector('[data-showcase-prev]');
      this.nextBtn = this.querySelector('[data-showcase-next]');
      this.total = this.images.length;

      let initial = parseInt(this.dataset.initialIndex || '0', 10);
      if (Number.isNaN(initial) || initial < 0) initial = 0;
      if (initial >= this.total) initial = Math.max(0, this.total - 1);
      this.currentIndex = initial;

      this.prevBtn?.addEventListener('click', () => this.step(-1));
      this.nextBtn?.addEventListener('click', () => this.step(1));

      this.update();
    }

    step(delta) {
      if (this.total < 1) return;
      this.currentIndex = (this.currentIndex + delta + this.total) % this.total;
      this.update();
    }

    update() {
      const cur = this.currentIndex;
      const prev = this.total > 1 ? (cur - 1 + this.total) % this.total : cur;
      const next = this.total > 1 ? (cur + 1) % this.total : cur;

      const center = 'showcase-carousel__img-wrap--center';
      const left = 'showcase-carousel__img-wrap--left';
      const right = 'showcase-carousel__img-wrap--right';
      const hidden = 'showcase-carousel__img-wrap--hidden';

      this.images.forEach((el, i) => {
        el.classList.remove(center, left, right, hidden);
        if (this.total <= 1) {
          el.classList.add(center);
        } else if (i === cur) {
          el.classList.add(center);
        } else if (i === prev) {
          el.classList.add(left);
        } else if (i === next) {
          el.classList.add(right);
        } else {
          el.classList.add(hidden);
        }
      });

      this.contents.forEach((el, i) => {
        el.classList.toggle('showcase-carousel__content--active', i === cur);
      });
    }
  }

  if (!customElements.get(TAG)) {
    customElements.define(TAG, ProductShowcaseCarousel);
  }
})();
